import { Actiontype, CreatePatientActionHistoryFieldsInput, Maybe } from '@saas/interfaces/graphql'
import axios from 'axios'
import { useFormContext } from 'react-hook-form'
import { UserRpps } from '@saas/interfaces/core'
import { CreateAndAddActionHistoryProps, FormatedPatientFormData, InsOidTypeLabel, WorkbenchStatus } from './_props'
import { FetchedPatientFragment } from '../../../api/queries/__generated__/patient.gql'

export const getFirstNamesValues = (firstNameList: FetchedPatientFragment['firstNameList']) =>
    (firstNameList ?? [])?.reduce<string[]>((prev, curr) => {
        if (curr?.__typename === 'Element' && curr.value) {
            prev.push(curr.value)
        }
        return prev
    }, [])

export const makeActionHistoryUpdatedByLabel = (firstName: string, lastName: string) => `${firstName} ${lastName}`

export const historyActionType: Record<Actiontype, Actiontype> = {
    ACCESS: 'ACCESS',
    DELETE: 'DELETE',
    CREATE: 'CREATE',
    SYNC: 'SYNC',
    UPDATE: 'UPDATE',
    SERVER: 'SERVER',
}

export function isHistoryActionType(action: string): action is Actiontype {
    const historyActionTypeMap = Object.values(historyActionType).map((x) => x.toString())
    return historyActionTypeMap.includes(action)
}

export function checkIsHistoryActionType(input: string): Actiontype | undefined {
    if (isHistoryActionType(input)) {
        return input
    }
    return undefined
}

export const createAndAddActionHistory = ({
    patientId,
    user,
    mode,
    actionDetails,
    actionInsiDetails,
}: CreateAndAddActionHistoryProps) => {
    const result: CreatePatientActionHistoryFieldsInput = {
        actionDate: new Date().toISOString(),
        patient: {
            link: patientId,
        },
        updatedBy: {
            link: user.id,
        },
        actionType: mode,
        isTechnical: false,
        updatedByLabel: makeActionHistoryUpdatedByLabel(user.firstName, user.lastName),
        actionDetails,
        actionInsiDetails,
    }

    return result
}

export const getFormatedRequiredExpert = async (requiredExpertID: string, token: string) => {
    const { data } = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/user/infos/${requiredExpertID}`, {
        headers: {
            'X-Session-Token': token,
        },
    })

    const result: UserRpps = {
        __typename: 'UserRpps',
        codecivilite: data.prefix,
        codecivilitedexercice: data.prefix,
        identifiantpp: data.rpps,
        libellesavoirfaire: data.speciality,
        nomdexercice: data.lastName,
        prenomdexercice: data.firstName,
        codeprofession: '',
        codesavoirfaire: '',
        firstName: '',
        lastName: '',
        libellecivilite: '',
        coderole: '',
        libellerole: '',
        userIdnps: 0,
        libelleprofession: '',
        libellecommunecoordstructure: '',
    }

    return result
}

export const YES = 'Oui'
export const NO = 'Non'

export const validateUnrequiredStringValue = (val: Maybe<string> | undefined) => {
    const length = val?.length ?? 0
    if (length > 0) {
        return (val?.trim().length ?? 0) > 0
    }
    return true
}

export const InsOidLabelValueRecord: Record<string, InsOidTypeLabel> = {
    '1.2.250.1.213.1.4.8': 'NIR',
    '1.2.250.1.213.1.4.9': 'NIA',
}

export const ReactHookFormFakeEvent = new Event('react hook form fake change event')

export const insNumMinLength = 15

export const socialSecurityNumberMinLength = 15

export const attachmentOrgMaxLength = 9

export const useFormContextPatient = useFormContext<FormatedPatientFormData>

const workbenchConflictStatuses: WorkbenchStatus[] = ['enter', 'stay']
const workbenchNoConflictStatuses: Array<WorkbenchStatus | undefined> = ['leave', undefined]

export const workbenchStatuses = {
    conflict: workbenchConflictStatuses,
    noConflict: workbenchNoConflictStatuses,
}
